import { useMutation } from "@tanstack/react-query"

import { client } from "@/api"
import { CreateNewEventFormDataType } from "@/pages/CreateEvent"
// import { useQueryClient } from "@tanstack/react-query"
// import queryKeys from "@/api/queryKeys"

function useCreateEvent() {
  //   const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (data: CreateNewEventFormDataType) => {
      return client.post(`/events`, data).then((response) => response.data)
    },
    // onSuccess: () => {
    //   queryClient.invalidateQueries({
    //     queryKey: queryKeys.events._def,
    //   })
    // },
  })
}
export default useCreateEvent
